export default "/images/1aa9ad845092ef8fa6ddae3ba47fc844.png";